
// import React from 'react'
// import Bannerspage from "./Bannerspage";
// import Newscreen from "./Newscreen";
// import Aboutsubscription from "./Aboutsubscription";
// import "./Homes.css";
// import { Link } from "react-router-dom";

// function Homes() {
//   return (
//     <div>
//       <div className=' home-banner-scrolling'
//         style={{
//           marginTop: "105px",
//           marginBottom: "50px",
//           overflow: "auto",
//           scrollbarWidth: "none",
//           width: "100vw",
//           marginLeft: 0,
//           padding: 0
//         }}>
//         <div style={{ width: "100%" }}>
//           <Bannerspage />
//         </div>
//         <div style={{ width: "100%" }}>
//           <Aboutsubscription />
//           <Newscreen />
//         </div>
//         <br></br>
//       </div>
//     </div>
//   )
// }

// export default Homes




import React, { useState } from "react";


import Foodsubscriptionpage from './Foodsubscriptionpage';
import Engeeringsubscription from './Engeeringsubscription';
/* ---------- Dummy Section Component ---------- */
const DummySection = ({ title }) => {
  return (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );
};

/* ---------- Main Company Component ---------- */
const Foodsubscription = () => {
  const tabs = [
    { id: 1, name: "FOOD& BEVERAGES", component: () => <Foodsubscriptionpage title="FOOD& BEVERAGES" /> },
    { id: 2, name: "Engineering", component: () => <Engeeringsubscription title="Engineering Subscription" /> },

  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="company-container">

      {/* 🔹 Inline CSS */}
      <style>{`
   /* Default (Mobile first) – kuch change nahi */
   .company-scroll-container {
     position: static;
     background: #fff;
   }
 
   .company-buttons-row {
     display: flex;
     // gap: 10px;
     flex-wrap: wrap;
   }
 
   .company-button {
     padding: 8px 16px;
     border: none;
     background: #f0f0f0;
     cursor: pointer;
     border-radius: 6px;
     white-space: nowrap;
   }
 
   .company-button.active {
     background: #e66d33;
     color: #fff;
   }
 
   /* ✅ Desktop / Laptop only */
   @media (min-width: 769px) {
     .company-scroll-container {
       position: sticky;
       top: 0;
       z-index: 100;
       padding: 10px 0;
     }
   }
 `}</style>


      {/* Tabs */}
      <div className="company-scroll-container">
        <div className="company-buttons-row">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`company-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      {/* Active Section */}
      <div className="component-display">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};


export default Foodsubscription; 